import { PropsWithChildren } from "react";
import {
  borderClassName,
  roundedClassName,
  sizeClassName,
  textFontClassName,
  transitionClassName,
} from "./commonClassNames";
import { ChildrenOnlyProp, ColorProps, BorderProps, SizeProp, TextFontProps } from "./commonProps";

type ChipColorProps = Pick<ColorProps, "primary">;
type ChipFontProps = Pick<TextFontProps, "font">;

export type ChipProps = React.HTMLAttributes<HTMLDivElement> &
  ChipColorProps &
  ChipFontProps &
  BorderProps &
  SizeProp & {
    className?: string;
    disabled?: boolean;
    title?: string;
  };

function chipColorClassName({ primary, disabled }: ChipColorProps & { disabled?: boolean }) {
  switch (true) {
    case disabled:
      return "text-neutral-600";
    case primary:
      return "bg-primary-100 hover:text-primary-200";
    default:
      return "text-neutral-600 hover:text-primary-200";
  }
}

export const Chip: React.FC<PropsWithChildren<ChipProps>> = ({
  children,
  grouped,
  border,
  primary,
  size,
  font,
  className,
  disabled,
  title,
  onClick,
  ...props
}) => {
  const combinedClassName = [
    "inline-flex items-center select-none whitespace-nowrap",
    borderClassName({ border, grouped }),
    roundedClassName({ grouped }),
    chipColorClassName({ primary, disabled }),
    textFontClassName({ font }),
    sizeClassName({ size }),
    transitionClassName({ colors: true }),
    className ?? "",
  ].join(" ");

  return (
    <div onClick={disabled ? undefined : onClick} className={combinedClassName} title={title} {...props}>
      {children}
    </div>
  );
};

export const ChipGroup: React.FC<ChildrenOnlyProp> = ({ children }) => {
  return <div className="flex flex-row">{children}</div>;
};
